<script setup lang="ts">
import type { TraderMarketStrategyData } from '../../server/detail/index'

const { marketStrategy } = defineProps<{
  marketStrategy?: TraderMarketStrategyData | null
}>()

const { t } = useAppI18n()
const emit = defineEmits<{
  open: []
}>()
</script>

<template>
  <section
    class="exchange-influence-card"
    role="button"
    tabindex="0"
    aria-labelledby="exchange-influence-title"
    aria-label="查看影响力详情"
    @click="emit('open')"
    @keydown.enter.prevent="emit('open')"
    @keydown.space.prevent="emit('open')"
  >
    <header class="exchange-influence-card__header">
      <h2 id="exchange-influence-title" class="exchange-influence-card__title">
        {{ t('83880') }}
      </h2>
    </header>

    <div class="exchange-influence-card__body">
      <div class="exchange-influence-card__grade-row">
        <span class="exchange-influence-card__grade font-wiki-Bold">{{ marketStrategy?.influence?.level }}</span>
        <span class="exchange-influence-card__grade-label"> {{ t('83883') }} </span>
      </div>

      <div class="exchange-influence-card__region-box">
        <p class="exchange-influence-card__region-label">{{ t('84583') }}</p>
        <div class="exchange-influence-card__country-row">
          <CommonImage
            :src="marketStrategy?.influence?.country?.[0]?.countryFlag"
            :alt="`${marketStrategy?.influence?.country?.[0]?.countryName} flag`"
            class="exchange-influence-card__flag"
            loading="eager"
          />
          <span class="exchange-influence-card__country-name"
            >{{ marketStrategy?.influence?.country?.[0]?.countryName
            }}{{ (marketStrategy?.influence?.country?.length ?? 0) > 1 ? '...' : '' }}</span
          >
        </div>
      </div>
    </div>
  </section>
</template>
<style scoped lang="less">
.exchange-influence-card {
  display: flex;
  min-height: 212px;
  width: 100%;
  flex-direction: column;
  gap: 20px;
  border: 0.5px solid rgba(11, 18, 40, 0.14);
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
  padding: 20px;
  transition:
    box-shadow 0.2s ease,
    transform 0.2s ease;
}

.exchange-influence-card:hover {
  box-shadow: 0 12px 32px rgba(8, 19, 62, 0.08);
}

.exchange-influence-card:focus-visible {
  outline: 2px solid rgba(17, 45, 115, 0.28);
  outline-offset: 2px;
}

.exchange-influence-card__header {
  display: flex;
  align-items: center;
  width: 100%;
}

.exchange-influence-card__title {
  margin: 0;
  color: #292a2e;
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
}

.exchange-influence-card__body {
  display: flex;
  min-height: 0;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}

.exchange-influence-card__grade-row {
  display: flex;
  align-items: baseline;
  gap: 4px;
  width: 100%;
}

.exchange-influence-card__grade {
  color: #292a2e;
  font-size: 40px;
  font-weight: 700;
  line-height: 1;
}

.exchange-influence-card__grade-label {
  color: #292a2e;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
}

.exchange-influence-card__region-box {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 8px;
  border: 0.5px solid rgba(5, 21, 36, 0.06);
  border-radius: 4px;
  background: #fff;
  padding: 8px 12px;
}

.exchange-influence-card__region-label {
  margin: 0;
  color: #505258;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
}

.exchange-influence-card__country-row {
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
}

.exchange-influence-card__flag {
  width: 18px;
  height: auto;
  flex: 0 0 auto;
  border-radius: 1px;
  object-fit: cover;
}

.exchange-influence-card__country-name {
  min-width: 0;
  color: #292a2e;

  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
